export interface PeerSet {
  id: string;
  title: string;
  subtitles: string[];
}

const format = (s: string | null | undefined): string =>
  !s || s === "MATCH_SELECTED_PROPERTY"
    ? ""
    : s
      .toLowerCase()
      .replace(/\b\w/g, (c: string) => c.toUpperCase());

export const fetchPeerSets = async (
  propertyId: string | number,
): Promise<{ peerSets: PeerSet[]; defaultPeerSet: PeerSet | null }> => {
  try {
    const baseUrl = process.env.REACT_APP_API_LAYER_URL;
    const response = await fetch(`${baseUrl}/peer-sets/${propertyId}`);
    if (!response.ok) {
      return { peerSets: [], defaultPeerSet: null };
    }
    const data = await response.json();
    const items: any[] = Array.isArray(data) ? data : (data?.data ?? []);

    const peerSets: PeerSet[] = items.map((ps: any) => {
      // const line1 = [ps.market_country, ps.room_band]
      //   .map(format)
      //   .filter(Boolean)
      //   .join(" • ");
      // const line2 = [ps.property_type, ps.star_rating]
      //   .map(format)
      //   .filter(Boolean)
      //   .join(" • ");
      // const subtitles = [line1, line2 ? `• ${line2}` : ""].filter(Boolean);
      const subtitles = ps?.filter
        ?.toLowerCase()
        .replace(/\b\w/g, (char: any) => char.toUpperCase());
      return {
        id: ps.peer_set_id,
        title: ps.peer_set_name,
        subtitles,
      };
    });

    const defaultItem = items.find((ps: any) => ps.is_default === true);
    const defaultPeerSet = defaultItem
      ? peerSets.find((ps) => ps.id === defaultItem.peer_set_id) ?? null
      : null;

    return { peerSets, defaultPeerSet };
  } catch (err) {
    console.error("Failed to fetch peer sets", err);
    return { peerSets: [], defaultPeerSet: null };
  }
};
